import { Container } from 'react-bootstrap'
import { HowItWorksFeaturesContainer } from './style'
import { useTranslation } from 'react-i18next'
import { BsArrowRight } from 'react-icons/bs'
import { HELP_DESK } from 'services/constants'
import { DataContext } from 'contexts/DataContextContainer'
import { useContext } from 'react'

function HowItWorksFeatures() {
  const { t } = useTranslation()
  const { lang } = useContext(DataContext)
  const contents = [
    {
      description: t('how_feature_content1'),
    },
    {
      description: t('how_feature_content2'),
    },
    {
      description: t('how_feature_content3'),
    },
    {
      description: t('how_feature_content4'),
    },
    {
      description: t('how_feature_content5'),
    },
  ]

  return (
    <HowItWorksFeaturesContainer>
      <Container className="h-100">
        <h2>{t('how_feature_title')}</h2>
        <div className="how-features-wrapper">
          <ol>
            {contents.map((_content, _i) => (
              <li key={_i} className="how-features-item">
                {_content.description}
              </li>
            ))}
            <a href={HELP_DESK['main'][lang]}>
              {t('help_center')} <BsArrowRight />
            </a>
          </ol>
        </div>
      </Container>
    </HowItWorksFeaturesContainer>
  )
}

export default HowItWorksFeatures
